import React from 'react'

function MS_program_details() {
  return (
    <div>
    {/* ------------------------Mobile view------------------ */}
    <div className='d-sm-block d-md-none'>
      <div className='container'>
        <div className='row'>
            <div className='col-md-12 detail_1stcomp_img'>
                <div className='Mobile_view_Program_details_1stcomp_text text-center'>
                    <h1 className='display-6'>The Mern Magic</h1>
                    <p className='py-2'>Dive into the dynamic world of MERN Stack! Enroll now in this advanced program to master MongoDB, Express.js, React, and Node.js. Illuminate your path to a brighter future!</p>
                </div>
                <div className='mt-4 Mobile_view_Program_details_1stcomp_text text-center'>
                    <h1 className='display-4'>Overview</h1>
                    <p className='py-2'>Take a look at the exciting field of web development with our in-depth MERN stack course. Beginning with laying a solid foundation in HTML, CSS, and JavaScript, you can go on to learn React for effective front-end development, explore Node.js and Express.js for reliable server-side applications, and use MongoDB for seamless database administration. Git version control is included in this practical course, so you'll be prepared to develop, implement, and oversee cutting-edge projects. With our MERN stack course, you can improve your abilities and realise your ideas.</p>
                </div>
            </div>
            <div className='col-md-12'>
                <div>
                <div className=' Details_container shadow-lg px-3 py-4'>
                <h1 className='mobile_view_Details_text text-center  pb-2 border-bottom'>Mern Stack</h1>
                  <div className='mobile_view_Details_text'>
                    <ul className='pt-2'>
                      <li>Live conversations with industry professionals</li>
                      <li className='py-3'>Project support and Guidance</li>
                      <li>Access to Specialized Course Materials</li>
                      <li className='py-3'>25+ Hours of Learning</li>
                      <li>Certificates from reputable MNC's around the world</li>
                    </ul>
                  </div>
                  <div className='text-center'>
                  {/* <a href=''><button className="text-white shadow-sm mt-3 fs-5 px-5 pt-1 pb-2 Pr_details_button">Enroll Now</button></a> */}
                  </div>
                </div>
                </div>
            </div>
        </div>
      </div>
    </div>

    {/* ------------------------Desktop View----------------------- */}
    <div className='d-none d-md-block'>
      <div className='container'>
        <div className='row'>
            <div className='col-md-8 detail_1stcomp_img'>
                <div className='pt-3 Program_details_1stcomp_text'>
                    <h1 className='display-6'>The Mern Magic</h1>
                    <p className='py-4'>Dive into the dynamic world of MERN Stack! Enroll now in this advanced program to master MongoDB, Express.js, React, and Node.js. Illuminate your path to a brighter future!</p>
                </div>
                <div className='mt-3 Program_details_1stcomp_text'>
                    <h1 className='display-3'>Overview</h1>
                    <p className='py-4'>Take a look at the exciting field of web development with our in-depth MERN stack course. Beginning with laying a solid foundation in HTML, CSS, and JavaScript, you can go on to learn React for effective front-end development, explore Node.js and Express.js for reliable server-side applications, and use MongoDB for seamless database administration. Git version control is included in this practical course, so you'll be prepared to develop, implement, and oversee cutting-edge projects. With our MERN stack course, you can improve your abilities and realise your ideas.</p>
                </div>
            </div>
            <div className='col-md-4'>
                <div>
                <div className=' Details_container shadow-lg px-3 pt-4 pb-5'>
                <h1 className='Details_text text-center  pb-4 pt-3 border-bottom'>Mern Stack</h1>
                  <div className='Details_text '>
                    <ul className='pt-4'>
                      <li>Live conversations with industry professionals</li>
                      <li className='py-3'>Project support and Guidance</li>
                      <li>Access to Specialized Course Materials</li>
                      <li className='py-3'>25+ Hours of Learning</li>
                      <li>Certificates from reputable MNC's around the world</li>
                    </ul>
                  </div>
                  <div className='text-center'>
                  {/* <a href=''><button className="text-white shadow-sm mt-3 fs-5 px-5 pt-1 pb-2 Pr_details_button">Enroll Now</button></a> */}
                  </div>
                </div>
                </div>
            </div>
        </div>
      </div>
    </div>
    </div>
  )
}

export default MS_program_details
